import React, { useState, useEffect } from "react";
import InboxSideBar from "./SideBar/InboxSideBar.js";
import InboxContent from "./Content/InboxContent.js";
import LightBoxManager from "../../Structure/LightBoxManager/LightBoxManager.js";
import InboxTourWrapper from "./InboxTourWrapper.js";
import { useUser } from "contexts/userContext/userContext.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import useInbox from "hooks/useInbox.ts";
import { useContent } from "contexts/contentContext/contentContext.js";
import { usePicker } from "contexts/pickerContext/pickerContext.ts";
import useSuspendedUser from "hooks/useSuspendedUser.ts";
import SubscriptionExpirationReminder from "../../Structure/Page/components/SubscriptionExpirationReminder/index.tsx";

import config from "config";

import "./Inbox.scss";

const Inbox = () => {
  const { desktopCondition } = useMediaQueries();
  const { isLoggedIn, getIsPendingLogin, getUserData } = useUser();
  const { fetchLabels, fetchInboxMailsCount } = useInbox();
  const { getPath } = useContent();
  const { fetchPickerProjectsCount } = usePicker();

  const [showReminder, setShowReminder] = useState(window.innerWidth >= 1200);

  useEffect(() => {
    if (getUserData()?.UserEncryptedId) {
      fetchInboxMailsCount({
        userId: getUserData()?.UserEncryptedId,
      });
    }
  }, []);

  useEffect(() => {
    if (getUserData()?.UserEncryptedId) {
      fetchPickerProjectsCount(getUserData()?.UserEncryptedId);
    }
  }, [getUserData()?.UserEncryptedId]);
  const { isUserSuspended } = useSuspendedUser();

  useEffect(() => {
    if (isUserSuspended) {
      window.location.href =
        window.location.origin + "/l" + getPath() + "suspended-user";
    }
  }, [isUserSuspended]);

  useEffect(() => {
    if (!isLoggedIn() && !getIsPendingLogin()) {
      window.location.href = config.baseurl + getPath() + "home";
    }
  }, [isLoggedIn(), getIsPendingLogin()]);

  useEffect(() => {
    if (getUserData()?.UserId) {
      fetchLabels();
    }
  }, [getUserData()?.UserId]);

  useEffect(() => {
    const handleResize = () => {
      setShowReminder(window.innerWidth >= 1200);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {showReminder && <SubscriptionExpirationReminder />}
      <div className="inbox-container" id="inbox-container">
        <InboxTourWrapper />
        <LightBoxManager ignoreUrl />
        {desktopCondition && <InboxSideBar />}
        <InboxContent />
      </div>
    </>
  );
};
export default Inbox;
